export const useProgress = (): ProgressState => {
  const progress = {
    total: ref(0),
    progress: ref(0),
    status: ref(''),
    reset() {
      progress.status.value = ''
      progress.progress.value = 0
      progress.total.value = 0
    },
    addWork(amount: number = 1) {
      progress.total.value += amount
    },
    makeProgress(task: string = '', amount: number = 1) {
      progress.status.value = task
      progress.progress.value += amount
    },
    get percent() {
      return progress.total.value ? Math.round((progress.progress.value / progress.total.value) * 100) as number : 0
    }
  } as ProgressState

  return progress
}
